function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.835 15l5 5a2.122 2.122 0 003 0v0a2.122 2.122 0 000-3l-5-5",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M20.916 5.847a.19.19 0 01.05.085c.47 1.567.107 3.33-1.131 4.568-1.251 1.251-3.038 1.61-4.617 1.117L6.87 19.964c-.813.813-2.14.874-2.98.09A2.122 2.122 0 013.835 17l8.383-8.383c-.492-1.579-.134-3.366 1.117-4.617 1.238-1.238 3-1.602 4.568-1.132a.2.2 0 01.085.051l.162.162a.2.2 0 010 .283L15.515 6l2.32 2.32 2.636-2.636a.2.2 0 01.283 0l.162.163v0zM2.933 4.293l.674 2.023A1 1 0 004.556 7h2.279V4.721a1 1 0 00-.684-.949l-2.023-.674a.5.5 0 00-.512.121l-.562.562a.5.5 0 00-.121.512v0z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.84 7l3.5 3.5",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgTools(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgTools;